/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { useDispatch } from 'react-redux';
import { updateCurrentPage } from 'state/slices/app';
// utils
// material
import { Button, displayModal } from '@insticator/insticator-ui';
import Space from 'material/space/space'
// content
// styles
import injectSheet from "react-jss";
import styles from './commentingv2activated_styles';

/* ========== ~~~~~~~~~~ COMMENTING 2.0 ACTIVATED ~~~~~~~~~~ ========== */
const CommentingV2Activated = injectSheet(styles)((props) => {
  const dispatch = useDispatch();

  const handleClose = () => dispatch(displayModal(false))

  const handleEditConfigurations = () => {
    handleClose()
    dispatch(updateCurrentPage('/dashboard/commenting/configuration'))
  }
  
  return (
    <Space direction={'column'} alignItems={'center'} justifyContent={'center'}>
      <h4>Commenting 2.0 Activated</h4>
      <Space direction={'column'} alignItems={'flex-start'} justifyContent={'flex-start'} gap={16} style={{textAlign: 'left',}}>
        <p>You have successfully activated the new Commenting 2.0 product for this site!</p>
        <p><strong>Legacy unit is no longer configurable. Client must integrate the new code on their live site before data migration can begin.</strong></p>
        <Space gap={0} direction={'column'}>
          <p style={{ textDecoration: 'underline'}}>Next Steps:</p>
          <ul>
            <li>Configure the new unit’s theme & features</li>
            <li>Client implements the code in a test page</li>
            <li>Client reviews and approves the product</li>
            <li>Client sets the new code live in production</li>
          </ul>
        </Space>
        <p className='errormessage'><strong>Once the new code is live, click “Start Migration” to being porting over the historical comments data into the new system.</strong></p>
      </Space>
      <Space style={{marginTop: '32px'}} alignItems={'center'} justifyContent={'center'}>
        <Button text='Close' variant='none' color='light' handleClick={handleClose} />
        <Button text={'Edit Configurations'} variant={'primary'} handleClick={handleEditConfigurations} />
      </Space>   
    </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default CommentingV2Activated